import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import headerLogo from "../../assets/headerLogo.png";
import watermark from "../../assets/watermark.png";
import AlertsDrawer from "../../components/Common/AlertsDrawer";
import DateRangeFilter from "../../components/Common/DateRangeFilter";
import FilterSelect from "../../components/Common/FilterSelect";
import FilterSelectActual from "../../components/Common/FilterSelectActual";
import { customDateConvert } from "../../components/Common/Utils/Utils";
import ActionButton from "../../components/FilterComponents/ActionButton";
import { NotificationContext } from "../../context/NotificationContext";
import useApi from "../../service/api.service";
import OpearatorPredictionTable from "./Components/OperatorPredictionTable";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

function Operator() {
  const { notifFlag, setNotifFlag, notifMessage } =
    useContext(NotificationContext);
  const [isMaximized, setIsMaximized] = useState(false);
  const [filterParts, setFilterParts] = useState("Suspicious");
  const [filterActualParts, setFilterActualParts] = useState("Scrap");
  const [updatedTable, setUpdatedTable] = useState([]);
  const [realTimeData, setRealTimeData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const API = useApi();
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const handleMaximize = () => {
    setIsMaximized(true);
  };

  const handleMinimize = () => {
    setIsMaximized(false);
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  };
  const filterContainerStyle = {
    // flex: 1,
    display: "flex",
    // justifyContent: "flex-end",
    alignItems: "center",
  };
  const allTabStyle = {
    fontSize: "12px",
    border: "1px solid #D4D4D4",
    borderRadius: "25px",
    marginRight: "10px",
  };
  const textStyle = {
    fontSize: "12px",
    marginRight: "10px",
    fontWeight: "500",
  };
  const styles = {
    mainSectionStyle: {
      width: "100%",
      minHeight: isMaximized ? "100vh" : `calc(100vh - 135px)`,
      position: isMaximized ? "fixed" : "relative",
      top: isMaximized ? 0 : "auto",
      bottom: isMaximized ? 0 : "auto",
      left: isMaximized ? 0 : "auto",
      right: isMaximized ? 0 : "auto",
      zIndex: isMaximized ? 9999 : "auto",
      backgroundColor: "#FFFFFF",
    },
    mainDivStyle: {
      display: "flex",
      margin: "20px 20px",
      justifyContent: "space-between",
      fontSize: "25px",
      fontWeight: 500,
      color: "#404040",
    },
    maximizeButtonStyle: {
      display: isMaximized ? "none" : "flex",
      alignItems: "center",
      gap: "5px",
      color: "#FFFFFF",
      fontSize: "15px",
      backgroundColor: "#0077B6",
      padding: "5px 20px",
      borderRadius: "20px",
      cursor: "pointer",
    },
    minimizeButtonStyle: {
      display: isMaximized ? "flex" : "none",
      alignItems: "center",
      gap: "5px",
      color: "#FFFFFF",
      fontSize: "15px",
      backgroundColor: "#0077B6",
      padding: "5px 20px",
      borderRadius: "20px",
      cursor: "pointer",
    },
    selectedButtonStyle: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      color: "white",
      height: "32px",
      fontSize: "12px",
      backgroundColor: "#0077B6",
      padding: "5px 20px",
      borderRadius: "20px",
      marginRight: "10px",
      fontWeight: 500,
      border: "1px solid #E4E4E4",
    },
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);
  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const defaultStartDate = new Date(Date.now() - oneWeek);
  const defaultEndDate = new Date(Date.now() - oneDay);

  const [finalDate, setFinalDate] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });
  const [openAlerts, setOpenAlerts] = useState(false);
  const handleClose = () => {
    setOpenAlerts(false);
  };
  const handleOpen = () => {
    setOpenAlerts(true);
    setNotifFlag(false);
  };
  const [pageData, setPageData] = useState({
    currentPage: 1,
    itemsPerPage: 10,
  });

  const [toggleDateFilter, setToggleDateFilter] = useState(false);
  const [value, setValue] = useState(1);
  const intervalRef = useRef(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setFinalDate({
        startDate: Date.now(),
        endDate: Date.now(),
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
    if (newValue === 1) {
      setFinalDate({
        startDate: Date.now() - 7 * 24 * 60 * 60 * 1000,
        endDate: Date.now() - 1 * 24 * 60 * 60 * 1000,
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
    if (newValue === 2) {
      setFinalDate({
        startDate: Date.now() - 30 * 24 * 60 * 60 * 1000,
        endDate: Date.now() - 1 * 24 * 60 * 60 * 1000,
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
  };

  useEffect(() => {
    if (dateRange[0].enabled) {
      setValue(null);
    }
    if (value === 0) {
      setValue(0);
    }
    if (value === 1) {
      setValue(1);
    }
    if (value === 2) {
      setValue(2);
    }
  }, [dateRange[0].enabled]);

  const fetchData = async () => {
    // console.log(finalDate, filterParts);
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: pageData.currentPage,
      limit: pageData.itemsPerPage,
    };

    try {
      setLoading(true);
      const response = await API.fetchOperatorTableData(customParams);
      setLoading(false);
      setUpdatedTable(response?.data?.parts);
      setPaginationData((prevState) => ({
        ...prevState,
        rowsPerPage: response?.data?.rowsPerPage,
        totalPages: response?.data?.totalPages,
        totalRows: response?.data?.totalRows,
      }));
      // console.log(updatedTable)
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchRealTimeData = async () => {
    // console.log(finalDate, filterParts);
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: pageData.currentPage,
      limit: pageData.itemsPerPage,
    };

    try {
      const response = await API.fetchOperatorTableData(customParams);
      setUpdatedTable(response?.data?.parts);
      setPaginationData((prevState) => ({
        ...prevState,
        rowsPerPage: response?.data?.rowsPerPage,
        totalPages: response?.data?.totalPages,
        totalRows: response?.data?.totalRows,
      }));
      // console.log("real",updatedTable)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchRealTimeData();
    }, 25000);

    return () => clearInterval(interval);
  }, [finalDate, filterParts, pageData, realTimeData, filterActualParts]);

  const fetchDataDownload = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: pageData.currentPage,
      limit: pageData.itemsPerPage,
      downloadFlag: true,
    };

    try {
      setLoading2(true);
      const response = await API.fetchOperatorTableData(customParams);
      if (response?.data?.length > 0) {
        handleDownload(response?.data);
        toast.success("Data downloaded successfully");
      } else {
        toast.error("No data to download");
      }
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleDownload = (data) => {
    const filteredData = data.map((obj) => {
      const {
        partSystemId,
        dryTunnelExitTime,
        highestContributingFactorName,
        highestContributingFactorPercentage,
        partCode,
        final_status,
        actualStatus,
        ...rest
      } = obj;
      return {
        "Part Id": partCode,
        Prediction: final_status,
        "Actual Status": actualStatus,
        "Dry Tunnel Exit Time": customDateConvert(
          dryTunnelExitTime,
          "MM/DD/YYYY HH:mm:ss"
        ),
        "Highest Contributing Factor Name": highestContributingFactorName,
        "Highest Contributing Factor Percentage":
          highestContributingFactorPercentage,
      };
    });
    const ws = XLSX.utils.json_to_sheet(filteredData);

    const setColumnWidths = (worksheet, data) => {
      const columnHeaders = Object.keys(data[0]);
      const columnWidths = columnHeaders.map((header, colIndex) => {
        const headerLength = header.length;
        const maxLength = data.reduce((max, row) => {
          const valueLength = row[header] ? row[header].toString().length : 0;
          return Math.max(max, valueLength);
        }, headerLength);
        return { wch: maxLength * 1.2 }; // Add some padding
      });
      worksheet["!cols"] = columnWidths;
    };
    setColumnWidths(ws, filteredData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Part Summary");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };

    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    const oneDay = 24 * 60 * 60 * 1000;
    const oneWeek = 7 * oneDay;
    const defaultStartDate = new Date(Date.now() - oneWeek);
    const defaultEndDate = new Date(Date.now() - oneDay);
    const startDate = finalDate.startDate
      ? new Date(finalDate.startDate)
      : defaultStartDate;
    const endDate = finalDate.endDate
      ? new Date(finalDate.endDate)
      : defaultEndDate;

    const a = document.createElement("a");
    a.href = url;
    a.download = `Scrap Prediction From ${customDateConvert(
      startDate,
      "MM-DD-YYYY"
    )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.xlsx`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };

  const onDownload = () => {
    fetchDataDownload();
  };

  const handleCloseNotif = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotifFlag(false);
  };

  const action = (
    <React.Fragment>
      <Button
        color="inherit"
        // sx={{color:"#fff"}}
        size="small"
        onClick={() => {
          handleCloseNotif();
          handleOpen();
        }}
      >
        Open
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseNotif}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Box sx={styles.mainSectionStyle}>
      <div style={styles.mainDivStyle}>
        <div style={containerStyle}>
          <Typography
            component="div"
            sx={{
              fontSize: "26px",
              color: "#404040",
              fontWeight: "600",
              whiteSpace: "nowrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              {isMaximized && (
                <div
                  style={{
                    textAlign: "center",
                    flex: 1.5,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <img
                    src={watermark}
                    alt="header"
                    width="20px"
                    height="20px"
                  />
                  <Divider
                    sx={{
                      backgroundColor: "#868686",
                      height: "22px",
                      width: "2px",
                    }}
                    orientation="vertical"
                    variant="middle"
                    flexItem
                  />
                  <img
                    src={headerLogo}
                    alt="header"
                    height="20px"
                    width="100px"
                  />
                </div>
              )}
              SCRAP PREDICTION
            </div>
          </Typography>
          {isMaximized && (
            <div
              style={{
                fontWeight: 500,
                color: "#444444",
                fontSize: "20px",
              }}
            >
              IAC COTTONDALE
            </div>
          )}
          <div style={filterContainerStyle}>
            <>
              {dateRange?.[0]?.enabled && (
                <Typography sx={textStyle}>
                  From {dateRange?.[0].startDate?.toLocaleDateString("en-US")}
                  {" To "}
                  {dateRange?.[0].endDate?.toLocaleDateString("en-US")}
                </Typography>
              )}
              {(dateRange?.[0]?.enabled || value != 1) && (
                <IconButton
                  onClick={() => {
                    setDateRange([
                      {
                        enabled: false,
                        startDate: null,
                        endDate: null,
                        key: "selection",
                        status: false,
                      },
                    ]);
                    // setValue(null);
                    setFinalDate({
                      startDate: null,
                      endDate: null,
                    });
                    setValue(1);
                  }}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    height: "30px",
                    width: "30px",
                    border: "1px solid #e4e4e4",
                    borderRadius: "20px",
                    marginRight: "10px",
                    fontSize: "12px",
                    "&:hover": {
                      backgroundColor: "#e4e4e4",
                      color: "white",
                    },
                  }}
                >
                  <ClearIcon
                    size="small"
                    sx={{
                      fontSize: "18px",
                    }}
                  />
                </IconButton>
              )}
            </>
            {!isMaximized && (
              <>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  centered
                  sx={{
                    "& .MuiTab-root": {
                      minHeight: "35px",
                      minWidth: "75px",
                      height: "35px",
                      color: "black",
                      fontWeight: 500,
                      textTransform: "Capitalize",
                    },
                    "& .MuiTabs-indicator": {
                      height: "0px",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#0077B8",
                      border: "1px solid #0077B6",
                      borderRadius: "25px",
                      color: "#FFFFFF !important",
                    },
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Tab style={allTabStyle} label="Today" />
                  <Tab style={allTabStyle} label="Past 7 Days" />
                  {/* <Tab style={allTabStyle} label="Past 30 Days" /> */}
                </Tabs>
              </>
            )}
            {isMaximized && (
              <>
                {value === 0 && (
                  <div style={styles.selectedButtonStyle}>Today</div>
                )}
                {value === 1 && (
                  <div style={styles.selectedButtonStyle}>Past 7 Days</div>
                )}
                {value === 2 && (
                  <div style={styles.selectedButtonStyle}>Past 30 Days</div>
                )}
              </>
            )}
            {!isMaximized && (
              <>
                {/* {!dateRange[0].enabled && ( */}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    columnGap: 1,
                    textTransform: "initial",
                    height: "32px",
                    width: "140px",
                    fontSize: "12px",
                    boxShadow: "none",
                    backgroundColor: "#fff",
                    color: "#404040",
                    fontSize: "12px",
                    border: "1px solid #D4D4D4",
                    borderRadius: "25px",
                    marginRight: "10px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => {
                    setToggleDateFilter(true);
                    // setValue(null);
                  }}
                >
                  Date Range
                  <CalendarMonthIcon sx={{ fontSize: "16px" }} />{" "}
                </Button>
              </>
            )}
            <FilterSelect
              filterParts={filterParts}
              setFilterParts={setFilterParts}
            />
            <FilterSelectActual
              filterParts={filterActualParts}
              setFilterParts={setFilterActualParts}
            />
            {!isMaximized && (
              <>
                <IconButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#0077B6",
                    padding: "6px",
                    marginRight: "10px",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#0077B6",
                      color: "white",
                    },
                  }}
                  onClick={onDownload}
                >
                  {loading2 ? (
                    <CircularProgress size={22} sx={{ color: "white" }} />
                  ) : (
                    <DownloadIcon
                      sx={{
                        fontSize: "22px",
                      }}
                    />
                  )}
                </IconButton>
              </>
            )}
            {!isMaximized && (
              <>
                <IconButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#0077B6",
                    padding: "6px",
                    marginRight: "10px",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#0077B6",
                      color: "white",
                    },
                  }}
                  onClick={handleMaximize}
                >
                  <ZoomOutMapIcon />
                </IconButton>
              </>
            )}
            {isMaximized && (
              <div style={styles.minimizeButtonStyle} onClick={handleMinimize}>
                <ZoomInMapIcon />
                Exit Fullscreen
              </div>
            )}
            <ActionButton label="Alerts" color="#0077B6" onClick={handleOpen} />
          </div>
          {openAlerts && (
            <AlertsDrawer
              handleClose={handleClose}
              open={openAlerts}
              finalDate={finalDate}
            />
          )}
          {toggleDateFilter && (
            <DateRangeFilter
              open={toggleDateFilter}
              onClose={() => {
                setToggleDateFilter(false);
              }}
              onApply={() => {
                setToggleDateFilter(false);
                setDateRange([
                  {
                    ...dateRange?.[0],
                    enabled: true,
                    status: !dateRange?.[0]?.status,
                  },
                ]);
                setFinalDate({
                  startDate: dateRange?.[0].startDate,
                  endDate: dateRange?.[0].endDate,
                });
                setValue(null);
              }}
              dateRange={dateRange}
              onChange={(data) => {
                setDateRange([
                  {
                    ...data?.[0],
                    status: dateRange?.[0]?.status,
                  },
                ]);
              }}
            />
          )}
        </div>
      </div>
      <Toaster />
      <OpearatorPredictionTable
        updatedTable={updatedTable}
        paginationData={paginationData}
        loading={loading}
        pageData={pageData}
        setPageData={setPageData}
        isMaximized={isMaximized}
      />
      {/* <ScrapModal open={open} handleClose={handleClose} /> */}
      {notifFlag && (
        <Snackbar
          open={notifFlag}
          autoHideDuration={null}
          onClose={handleCloseNotif}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            action={action}
            icon={
              <ReportProblemIcon
                sx={{
                  fontSize: "18px",
                  color: "#fff",
                }}
              />
            }
            severity="success"
            variant="standard"
            sx={{
              width: "100%",
              backgroundColor: "#EA4335",
              color: "#FFF",
              boxShadow: "0px 3px 6px #0000001F",
            }}
          >
            {notifMessage}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
}

export default Operator;
